import script from "./AvanceFactorPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./AvanceFactorPanel.vue?vue&type=script&lang=ts&setup=true"

import "./AvanceFactorPanel.vue?vue&type=style&index=0&id=370751b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370751b9"]])

export default __exports__